export default __webpack_public_path__ + "static/media/harvest_logo-removebg-preview.3e9afcda.png";